import { z } from "zod";

// Query for GET /api/partners/lookup?q=<string>. Min 3 chars; the route
// returns an empty array for anything shorter (legacy parity), so callers can
// still wire this schema to a debounced lookup field without a hard error on
// every keystroke.
export const partnersLookupQuerySchema = z.object({
  q: z.string().trim().min(3),
});

export type PartnersLookupQuery = z.infer<typeof partnersLookupQuerySchema>;
